import { GtagScript, GtagScriptProps } from '../tracking.model';

const getScript = (googleAnalyticsId: string, googleOptimizeId: string) => {
  return `
    window.dataLayer = window.dataLayer || []
    function gtag(){ dataLayer.push(arguments) }
    gtag('js', new Date())
    gtag('config', '${googleAnalyticsId}', { 'optimize_id': '${googleOptimizeId}' })
    gtag('consent', 'default', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied'
    })`;
};

/**
 * Note: Attributes type="text/plain" and data-usercentrics="Google Tag Manager" are added
 * to the gtag script, in order for the script to only be
 * activated once consent for Google Tag Manager is given.
 * @param gtag
 * @returns Global site tag (Gtag) script
 *
 * Global site tag is a tag management framework that acts as a common tool for running only Google tracking tools
 * such as Google Analytics, Google optimize etc.
 */
const gtagObject = (gtag: GtagScriptProps): GtagScript => {
  return {
    innerHTML: getScript(gtag.analyticsId, gtag.optimizeId),
    type: 'text/plain',
    'data-usercentrics': gtag['data-test-id'] ?? 'Google Tag Manager',
    id: gtag.id ?? 'gtag-cmp',
  };
};

export default gtagObject;
